export const GUIDENCE_TIPSEEN = 'guidence_tipseen';
export const EDIT_DOCUMENT_HEADER = 'edit_document_header';
